module.exports = __webpack_public_path__ + "img/industry-bg2.e3096aac.png";